import React from 'react';
import PropTypes from 'prop-types';
import withSelfStorageSchema from '@sparefoot/react-core/decorators/withSelfStorageSchema';
import { mapAmenitiesToFeature } from '../../config/amenityMap';

const withSelfStorageSchemaProps = (Component) => {
	const WithSelfStorageSchemaProps = ({
		facility,
		baseUrl,
		cloudfrontUrl,
		...rest
	}) => {
		const { location, units, images, url, reviews } = facility;

		let schemaPromotion = [];
		const { smallUnit, mediumUnit, largeUnit } = units;
		if (smallUnit?.special) {
			schemaPromotion = smallUnit.special;
		} else if (mediumUnit?.special) {
			schemaPromotion = mediumUnit.special;
		} else if (largeUnit?.special) {
			schemaPromotion = largeUnit.special;
		}

		// Adding images, these are jpgs
		let imagesWithUrl = [];
		if (images?.length) {
			imagesWithUrl = images.map(
				(image) => `https:${cloudfrontUrl}/medium-compress/${image}`,
			);
		}

		// Map amenities into schema.org amenityFeature using canonical mapping
		// Only pass facility
		const amenityFeature = mapAmenitiesToFeature(facility) || [];

		const enhancedFacility = {
			...facility,
			location: {
				...location,
			},
			amenityFeature,
			imagesWithUrl,
			staticMapUrl: facility?.staticMapUrl,
			reviews: {
				...reviews,
			},
			schemaUrl: `${baseUrl}${url}`,
		};

		return (
			<Component
				{...rest}
				facility={enhancedFacility}
				baseUrl={baseUrl}
				cloudfrontUrl={cloudfrontUrl}
				schemaPromotion={schemaPromotion}
			/>
		);
	};
	WithSelfStorageSchemaProps.propTypes = {
		facility: PropTypes.shape({
			location: PropTypes.object,
			units: PropTypes.shape({
				smallUnit: PropTypes.shape({
					special: PropTypes.oneOfType([
						PropTypes.array,
						PropTypes.string,
					]),
				}),
				mediumUnit: PropTypes.shape({
					special: PropTypes.oneOfType([
						PropTypes.array,
						PropTypes.string,
					]),
				}),
				largeUnit: PropTypes.shape({
					special: PropTypes.oneOfType([
						PropTypes.array,
						PropTypes.string,
					]),
				}),
			}),
			images: PropTypes.array,
			url: PropTypes.string,
			reviews: PropTypes.object,
			staticMapUrl: PropTypes.string,
		}).isRequired,
		baseUrl: PropTypes.string.isRequired,
		cloudfrontUrl: PropTypes.string,
	};
	WithSelfStorageSchemaProps.displayName = `withSelfStorageSchemaProps(${Component.displayName || Component.name || 'Component'})`;
	return WithSelfStorageSchemaProps;
};

const withSelfStorageSchemaComposed = (Component) =>
	withSelfStorageSchemaProps(withSelfStorageSchema(Component));

export default withSelfStorageSchemaComposed;
